import { ButtonProps } from "@mui/material";
import colors from "theme/base/colors";
import VidletButton from "./VidletButton";

export default function ActionButton({ children, sx, ...props }: ButtonProps) {
  return (
    <VidletButton
      sx={{
        backgroundColor: colors.grey[600],
        "&:hover": {
          backgroundColor: colors.primary.light,
        },
        ...sx,
      }}
      {...props}
    >
      {children || "ACTION"}
    </VidletButton>
  );
}
